import { render, staticRenderFns } from "./miniappStatistics.vue?vue&type=template&id=5a34bea2&"
import script from "./miniappStatistics.vue?vue&type=script&lang=js&"
export * from "./miniappStatistics.vue?vue&type=script&lang=js&"
import style0 from "./miniappStatistics.vue?vue&type=style&index=0&id=5a34bea2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a34bea2')) {
      api.createRecord('5a34bea2', component.options)
    } else {
      api.reload('5a34bea2', component.options)
    }
    module.hot.accept("./miniappStatistics.vue?vue&type=template&id=5a34bea2&", function () {
      api.rerender('5a34bea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/miniappStatistics.vue"
export default component.exports